// columns.js - WhatsApp App (Baileys) campaign columns
import { h } from 'vue';
import DataTableColumnHeader from 'dashboard/routes/dashboard/campaigns/pages/whatsapp_oficial/components/table/DataTableColumnHeader.vue';
import DataTableRowActions from 'dashboard/routes/dashboard/campaigns/pages/whatsapp_oficial/components/table/DataTableRowActions.vue';
import CampaignStatusProgress from 'dashboard/routes/dashboard/campaigns/pages/whatsapp_oficial/components/table/CampaignStatusProgress.vue';

export const columns = [
  {
    accessorKey: 'title',
    header: ({ column }) =>
      h(DataTableColumnHeader, { column, title: 'Título' }),
    cell: ({ row }) =>
      h(
        'div',
        { class: 'ml-2 mr-2 max-w-[300px] truncate' },
        row.getValue('title')
      ),
    enableGrouping: true,
    name: 'Título',
  },
  {
    accessorKey: 'inbox_name',
    id: 'inbox_name',
    header: ({ column }) =>
      h(DataTableColumnHeader, { column, title: 'Nome da Caixa de Entrada' }),
    cell: ({ row }) =>
      h(
        'div',
        { class: 'max-w-[200px] truncate text-center' },
        row.getValue('inbox_name')
      ),
    enableGrouping: true,
    name: 'Nome da Caixa de Entrada',
  },
  {
    id: 'source_type',
    accessorFn: row => {
      try {
        const fd =
          typeof row.filter_data === 'string'
            ? JSON.parse(row.filter_data)
            : row.filter_data || {};
        return fd.source_type || 'tag';
      } catch {
        return 'tag';
      }
    },
    header: ({ column }) => h(DataTableColumnHeader, { column, title: 'Tipo' }),
    cell: ({ row }) => {
      const sourceType = row.getValue('source_type');

      let label;
      let colorClass;
      let icon;

      if (sourceType === 'tag') {
        label = 'Tag';
        icon = 'i-lucide-tag';
        colorClass = 'text-n-green-11 bg-n-green-3';
      } else if (sourceType === 'database') {
        label = 'Banco de Dados';
        icon = 'i-lucide-database';
        colorClass = 'text-n-amber-11 bg-n-amber-3';
      } else if (sourceType === 'google_sheets') {
        label = 'Google Sheets';
        icon = 'i-lucide-sheet';
        colorClass = 'text-n-blue-11 bg-n-blue-3';
      } else {
        label = sourceType;
        icon = 'i-lucide-help-circle';
        colorClass = 'text-n-slate-11 bg-n-slate-3';
      }

      return h(
        'span',
        {
          class: `inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${colorClass}`,
        },
        [h('span', { class: `${icon} size-3.5` }), label]
      );
    },
    enableSorting: true,
    enableGrouping: true,
    name: 'Tipo',
  },
  {
    accessorKey: 'scheduled_at',
    id: 'scheduled_at',
    header: ({ column }) =>
      h(DataTableColumnHeader, { column, title: 'Agendado para' }),
    cell: ({ row }) =>
      h(
        'div',
        { class: 'max-w-[200px] truncate' },
        row.getValue('scheduled_at')
          ? new Date(row.getValue('scheduled_at')).toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })
          : '-'
      ),
    enableGrouping: true,
    name: 'Agendado para',
    filterFn: 'dateRange',
  },
  {
    accessorKey: 'campaign_status',
    id: 'campaign_status',
    header: ({ column }) =>
      h(DataTableColumnHeader, { column, title: 'Status da Campanha' }),
    cell: ({ row }) => {
      const data = row.original;
      const campaignId = data.campaign_id;
      const schedulingId = data.schedule_id;
      const statusFromData = data.campaign_status;
      const channelType = data.channel_type;

      const progressPercentage = data.progress_percentage || 0;
      const totalItems = data.total_items || 0;
      const itemsProcessed = data.items_processed || 0;

      const rawStatusData = data.status_data || {};
      const statusData = {
        ...rawStatusData,
        status:
          rawStatusData.status?.toLowerCase() || statusFromData?.toLowerCase(),
        items_sent: data.items_sent ?? 0,
        items_failed: data.items_failed ?? 0,
        total_items: totalItems,
        progress: progressPercentage,
        message: data.status_message || '',
        statistics: data.statistics || null,
      };

      const uniqueKey = `status-${campaignId}-${schedulingId}`;

      return h(CampaignStatusProgress, {
        key: uniqueKey,
        campaignId,
        schedulingId,
        initialStatus: statusFromData?.toLowerCase() || 'scheduled',
        channelType,
        statusData,
        progressPercentage,
        totalItems,
        itemsProcessed,
      });
    },
    enableGrouping: true,
    name: 'Status da Campanha',
    filterFn: (row, id, value) => {
      const status = row.getValue(id) || 'scheduled';
      return value.includes(status);
    },
  },
  {
    accessorKey: 'sender_name',
    id: 'sender_name',
    header: ({ column }) =>
      h(DataTableColumnHeader, { column, title: 'Usuário' }),
    cell: ({ row }) => {
      return h(
        'div',
        { class: 'max-w-[150px] truncate' },
        row.getValue('sender_name') || '-'
      );
    },
    enableGrouping: true,
    name: 'Usuário',
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      const data = row.original;
      const actionsKey = `actions-${data.campaign_id}-${data.schedule_id}`;

      return h(DataTableRowActions, {
        key: actionsKey,
        row,
      });
    },
    enableGrouping: false,
  },
];
